const SET_CUSTOM_FILTER_SEARCH_MYFLEET = 'common/SET_CUSTOM_FILTER_SEARCH_MYFLEET';

export { SET_CUSTOM_FILTER_SEARCH_MYFLEET };
